import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { Subscription } from 'rxjs';
import { AppService } from '../../../app/app.service';
import { LoadingService } from '../../../app/shared/services/loading.service';
import { TranslateService } from '../../../app/translate';
import { CompartViewModel, MeasurementPointsViewModel } from '../measurement-points-admin/model/measurement-points.model';
import { MeasurementPonitsService } from '../measurement-points-admin/services/measurement-points-service';
import { CustomerSelectItem } from '../setup-equipment/setup-equipment.model';
import { SetupEquipmentService } from '../setup-equipment/setup-equipment.service';

@Component({
  selector: 'app-manage-component-criticality',
  templateUrl: './manage-component-criticality.component.html',
  styleUrls: ['./manage-component-criticality.component.scss']
})
export class ManageComponentCriticalityComponent implements OnInit {
  private _userLanguage = 'english';
  typeList:CustomerSelectItem[] = [];
  makeList: CustomerSelectItem[] = [];
  modelList: CustomerSelectItem[] = [];
  selectedMakeId = 0;
  selectedModelId = 0;
  components: CompartViewModel[];
  compartId:number;
  compartViewModel: CompartViewModel;
  measurementPoints: MeasurementPointsViewModel[];
  componentTypePlusName: string;
  IsMeasurementShow:boolean=false;
  totalCompContribution:number=0;
  totalMPContribution:number=0;
  selectedfamilyId:number;

  private _subscriptions: Subscription[] = [];
  constructor(
    private _translate: TranslateService,
    private _appService: AppService,
    private _loading: LoadingService,
    private _router: Router,
    private _equipmentService: SetupEquipmentService,
    private _measurementPointsService: MeasurementPonitsService,
    private _notification: NotificationsService,
  )  { }

  ngOnInit() {
    this._appService.setPageTitle('Measurement Points');
    // this._equipmentService.getOEMMakeListByFamilyId(203).subscribe(result => this.makeList = result); //tt-5692 
  }


  LoadMakeList(){
    
    this._equipmentService.getOEMMakeListByFamilyId(this.selectedfamilyId).subscribe(result => this.makeList = result);
  }
  makeSelected() {
    this.IsMeasurementShow=false;

    //this.selectedModelId = 0;
    this._loading.startLoading();
    //this.selectedMakeId = selectedMakeId;

    this.modelList = [];

    this._subscriptions.push(this._equipmentService.GetModelListByfamilyandMake(this.selectedMakeId,this.selectedfamilyId).subscribe(r => {
      this.modelList = r;
      this._loading.finishedLoading();
    }));

    // this.pushMultipleSelection(5, selectedMakeId);
    // this._subscriptions.push(this._measurementPointsService.getFilteredComparts(this.comSearchItems).subscribe(result => {
    //   this.components = [];
    //   this.components = result;
    //   this._loading.finishedLoading();
    // }));

  }
  Translate(value: string): string {
    return this._translate.translateToLang(value, this._userLanguage);
  }
  


  modelSelected(selecedModelId: number) {
    this.IsMeasurementShow=false;
    this._loading.startLoading();
    this._subscriptions.push(this._measurementPointsService.getFilteredCompartsByModel(this.selectedModelId).subscribe(result => {
      this.components = [];
      this.components = result;
      // let totalPercentage =0;
      // this.components.map(x=>{
      //   let values= x.ContributionPercentage;
      //   totalPercentage = totalPercentage + values;
      // })
      //this.totalCompContribution = totalPercentage;
      this.GetTotalCompartContribution();
      this._loading.finishedLoading();
    }));

  }

  loadMeasurementPoints(compartId:number) {
    this.IsMeasurementShow=false;
    this.compartId = compartId;
    this._loading.startLoading();
    this._subscriptions.push(this._measurementPointsService.getCompartMeasurementPoints(compartId).subscribe(r => {
      this.compartViewModel = r.Compart;
      this.measurementPoints = r.MeasurementPointsViewModels;
      this.componentTypePlusName = r.Compart.CompartType + "(" + r.Compart.CompartName + ")";
      let totalPercentage =0;
      this.measurementPoints.map(x=>{
        let values= x.ContributionPercentage;
        totalPercentage = totalPercentage + values;
      })

      this.totalMPContribution = totalPercentage;
      this._loading.finishedLoading();
      this.IsMeasurementShow=true;
    }));
  }
  
  GetTotalCompartContribution(){
    let total = 0;
      this.components.map(x=>{
        if(x.ContributionPercentage!=null){
          let contribute = Number(x.ContributionPercentage)
          if(x.CompartType=="TrackRoller"){
            contribute = contribute*8;
            x.calculatedPercent = x.ContributionPercentage * 8
          }else if (x.CompartType=="CrawlerFrameGuide"){
            contribute = contribute*2;
            x.calculatedPercent = x.ContributionPercentage * 2
          }
          total = Number(total)+ contribute;
        }
      })
    
      this.totalCompContribution = total;
  }

  AddCompartContributionPercentage(event:any,component:CompartViewModel){
    let val =event.target.value;
    if(val>=0){
      this._measurementPointsService.UpdateContributionForCompartPercentage(component.CompartId, this.selectedModelId, val).subscribe((succeeded: any)=>{
        this._loading.finishedLoading();
        if (succeeded.m_Item1 === -1){
          this._notification.error('Failed', succeeded.m_Item2);
        }
        else{
          this._notification.success('Saved', succeeded.m_Item2 );
         
        }
      })
    }
    component.ContributionPercentage = val;
    this.components.map(x=>{
      if(x.CompartId == component.CompartId){
        x.ContributionPercentage = val;
        
      }
    })
    this.GetTotalCompartContribution();
    
   
  }

  GetTotalMeasurementContribution(){
    let total = 0;
      this.measurementPoints.map(x=>{
        if(x.ContributionPercentage!=null){
          total = Number(total)+ Number(x.ContributionPercentage)
        }
      })
     
      this.totalMPContribution = total;
      
  }

  getColourMPTotal(){
    if(this.totalMPContribution>100 || this.totalMPContribution<100){
      return  'bushClass-X'
    }else{
      return 'bushClass-A'
    }
  }

  getColourCompartTotal(){
    if(this.totalCompContribution>100 || this.totalCompContribution<100){
      return  'bushClass-X'
    }else{
      return 'bushClass-A'
    }
  }
  AddMeasurementContributionPercentage(event:any,measurement:MeasurementPointsViewModel){
    let val = event.target.value;
    if(val>=0){
      this._measurementPointsService.UpdateContributionForMeasurementPointPercentage(measurement.MeasurementPonitId, val).subscribe((succeeded: any)=>{
        this._loading.finishedLoading();
        if (succeeded.m_Item1 === -1){
          this._notification.error('Failed', succeeded.m_Item2);
        }
        else{
          this._notification.success('Saved', succeeded.m_Item2 );
         
        }
      })
    }
    measurement.ContributionPercentage = val;
    this.measurementPoints.map(x=>{
      if(x.MeasurementPonitId == measurement.MeasurementPonitId){
        x.ContributionPercentage = val;
        
      }
    })
    this.GetTotalMeasurementContribution();
    
   
  }
   amount(item){
    return item.Amount;
  }
  
   sum(prev, next){
    return prev + next;
  }
}
